<template>
  <div class="art_box">
    <div class="lf_box">
      <div class="title">代理录单：</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="用户ID" prop="userId">
          <el-input type="text" v-model.trim="ruleForm.userId" @blur.native.capture="onChange" @focus.capture="onChangef" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="代理RID" prop="rid">
          <el-input type="text" v-model.trim="ruleForm.rid"></el-input>
        </el-form-item>
        <el-form-item label="付款状态" prop="paid">
          <el-radio-group v-model="ruleForm.paid">
            <el-radio :label="true">已支付</el-radio>
            <el-radio :label="false">未支付</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="产品名称" prop="productId">
          <el-select v-model.trim="ruleForm.productId" placeholder="请选择产品名称" @change="setOrder">
            <el-option 
              v-for="item in tableData"
              :key="item.id"
              :label="item.productName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单份数" prop="num">
          <el-input type="text" v-model.trim="ruleForm.num" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="预售单号">
          <el-input type="text" v-model.trim="ruleForm.preorderCode" onkeyup="value=value.replace(/[\W]/g,'')"></el-input>
        </el-form-item>
        <div class="title" style="font-size:18px">收款情况：</div>
        <el-form-item label="RMB" prop="cny">
          <el-input  v-model="ruleForm.cny" oninput="value=value.replace(/[^0-9.]/g,'')" :disabled="!ruleForm.paid"></el-input>
        </el-form-item>
        <el-form-item label="USDT" prop="usdt">
          <el-input  v-model="ruleForm.usdt" oninput="value=value.replace(/[^0-9.]/g,'')" :disabled="!ruleForm.paid"></el-input>
        </el-form-item>
        <el-form-item label="FIL" prop="fil">
          <el-input  v-model="ruleForm.fil" oninput="value=value.replace(/[^0-9.]/g,'')" :disabled="!ruleForm.paid"></el-input>
        </el-form-item>
        <div class="title" style="font-size:18px">汇率信息：</div>
        <el-form-item label="FIL/USDT汇率" prop="filUsdt">
          <el-input  v-model="ruleForm.filUsdt" oninput="value=value.replace(/[^0-9.]/g,'')" ></el-input>
        </el-form-item>
        <el-form-item label="USDT/CNY汇率" prop="usdtCny">
          <el-input  v-model="ruleForm.usdtCny" oninput="value=value.replace(/[^0-9.]/g,'')" ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="rg_box">
      <div class="userInfo" v-if="userType&&userAll">
        <div class="tile">用户信息：</div>
        <div class="sam_box">
          <span>用户手机：</span>{{userAll.phone}}
        </div>
        <div class="sam_box">
          <span>用户邮箱：</span>{{userAll.email}}
        </div>
        <div class="sam_box">
          <span>推荐人RID：</span>{{userAll.agentRid}}
        </div>
        <div class="sam_box">
          <span>USDT：</span>{{userAll.usdt}}
        </div>
        <div class="sam_box">
          <span>FIL：</span>{{userAll.fil}}
        </div>
      </div>
      <div class="product" v-if="productAll">
        <div class="tile">产品信息：</div>
        <div class="sam_box">
          <span>单份算力：</span>{{productAll.singeNum}} TiB
        </div>
        <div class="sam_box">
          <span>合约周期：</span>{{productAll.contract}} 天
        </div>
        <div class="sam_box">
          <span>挖矿时间：</span>{{productAll.earnings}}
        </div>
        <div class="sam_box">
          <span>托管费用：</span>{{productAll.trus}} %
        </div>
        <div class="sam_box">
          <span>质押数：</span>{{productAll.pledge}} FIL
        </div>
        <div class="sam_box">
          <span>GAS费：</span>{{productAll.gasPledg}} FIL
        </div>
        <div class="sam_box">
          <span>剩余数量：</span>{{productAll.repertory}} 份
        </div>
        <div class="sam_box">
          <span>最小购买份数：</span>{{productAll.minNum}} 份
        </div>
        <div class="sam_box">
          <span>最大购买份数：</span>{{productAll.maxNum?productAll.maxNum+'份': '不限'}}
        </div>
        <div class="sam_box">
          <span>技术返点：</span>{{productAll.rebate}} %
        </div>
        <div class="sam_box">
          <span>固定成本：</span>{{productAll.fixCost}} USDT
        </div>
        <div class="sam_box">
          <span>折扣：</span>{{productAll.costDiscount}} %
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import selfFunc from '@/utils/common.js'
export default {
  data() {
    const validateMoney = (rule,value,callback) =>{
      if (!value) {
        this.$message.error('请输入代理RID');
      } else if (value) {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,8}$/
        if (!(reg.test(value))||value.length>7) {
          this.$message.error('请输入正确的代理RID');
          this.ruleForm.rid = ''
        }
        callback();
      }
    };
    const validateMoneys = (rule,value,callback) =>{
      if(value===null){
        callback(new Error('价格不能为空'))
      }else{
        if (value==0) {
          callback();
        } else {
          if (Math.floor(value) === value) {
            callback();
          } else {
            var reg = /^\d+(\.\d{1,4})?$/;
            if(!reg.test(value)){
              callback(new Error('最多只能输入小数后4位数')) //小数点后两位
            } else {
              callback();
            }
          }
        }
      }
    };
    return {
      ruleForm: {
        userId: '',
        rid: '',
        productId: '',
        num: '',
        usdt: '',
        fil: '',
        cny: '',
        filUsdt: '',
        usdtCny: '',
        preorderCode: '',
        paid: false
      },
      rules: {
        userId: [
          { required: true, message: '请输入用户ID', trigger: 'blur' },
        ],
        productId: [
          { required: true, message: '请选择产品', trigger: 'change' }
        ],
        rid: [
          { required: true, message: '请输入代理RID', trigger: 'change' }
        ],
        num: [
          { required: true, message: '请输入购买份数', trigger: 'blur' },
          { min: 1, max: 5, message: '购买份数不能超过99999份', trigger: 'blur' }
        ],
        usdt: [
          { required: true, validator:validateMoneys, trigger: 'blur' }
        ],
        fil: [
          { required: true, validator:validateMoneys, trigger: 'blur' }
        ],
        cny: [
          { required: true, validator:validateMoneys, trigger: 'blur' }
        ],
        filUsdt: [
          { required: true, message: '请输入汇率值', trigger: 'change' }
        ],
        usdtCny: [
          { required: true, message: '请输入汇率值', trigger: 'change' }
        ]
      },
      userType: false,
      userAll:null,
      tableData: [],
      productAll: null,
      channelList: []
    };
  },
  created() {
    this.getTableList()
    this.rateData()
  },
  watch:{
    'ruleForm.num': function(val) {
      if (!this.ruleForm.paid) {
        this.ruleForm.usdt = this.usdt?this.$selfFunc.toNonExponential(this.usdt*val,4):0
        this.ruleForm.fil = this.fil?this.$selfFunc.toNonExponential(this.fil*val,4):0
        this.ruleForm.cny = this.cny?this.cny*val:0
      }
    },
  },
  methods: {
    async rateData() {
      let res = await this.$http.commonCoinPrice();
      if(res) {
        console.log(res)
        this.ruleForm.filUsdt = res.data.filUsdt
        this.ruleForm.usdtCny = res.data.usdtCny
      }
    },
    setOrder(){
      this.tableData.map((item)=>{
        if(item.id==this.ruleForm.productId) {
          this.productAll = item
          if (!this.ruleForm.paid) {
            this.getProductPrice()
          }
        }
      })
      console.log(this.productAll)
    },
    async getProductPrice () {
      let data = {
        id: this.productAll.id
      }
       let res = await this.$http.productPrice({...data});
       if (res) {
         this.usdt = res.data.USDT
         this.fil = res.data.FIL
         this.cny = res.data.CNY
         this.ruleForm.usdt = res.data.USDT?res.data.USDT:0
         this.ruleForm.fil = res.data.FIL?res.data.FIL:0
         this.ruleForm.cny = res.data.CNY?res.data.CNY:0
          if (!this.fil) {
            setTimeout(()=>{
              this.$refs['ruleForm'].clearValidate(['fil'])
            },30)
            
          }
          if (!this.cny) {
            setTimeout(()=>{
              this.$refs['ruleForm'].clearValidate(['cny'])
            },30)
          }
       }
    },
    async onChange(){
      if (!this.ruleForm.userId) {
        this.$message.error('请输入用户ID');
        return false
      }
      if (this.ruleForm.userId.length>6){
        this.$message.error('用户ID不能大于6位');
        return false
      }
      let res = await this.$http.userInfo({id:this.ruleForm.userId});
      if(res) {
        if (res.data) {
          this.userAll=res.data
          this.userType = true
          // this.ruleForm.rid = this.userAll.agentRid
        }
      }
    },
    onChangef() {
      this.userAll = null
      this.userType = false
    },
    async getTableList(){
       let res = await this.$http.productInfo({type:2});
        if (res) {
          this.tableData=res.data
        }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (!this.ruleForm.rid) {
            this.$message.error('请输入代理RID');
            return false
          }
          if (this.ruleForm.rid) {
            var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,8}$/
            if (!(reg.test(this.ruleForm.rid))||this.ruleForm.rid.length>7) {
              this.$message.error('请输入正确的代理RID');
              return false
            }
          }
          if (this.ruleForm.preorderCode) {
            if (this.ruleForm.preorderCode.length<1||this.ruleForm.preorderCode.length>20) {
              this.$message.error('请输入正确的预售单号');
              return false
            }
          }
          let res = await this.$http.personOrder({...this.ruleForm});
          if (res){
            this.$message.success('操作成功！');
            if(this.ruleForm.paid) {
              this.$router.push({name:'auditOrderList'})
            }else {
              this.$router.push({name:'unpaidOrderCheckList'})
            }
          }
          
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.productAll=null
      this.userAll=null
      this.$refs[formName].resetFields();
    }
  }
}
</script>
<style scoped>
.art_box{
  width: 80%;
  height:900px;
  background: #fff;
  padding-top: 20px;
  display: flex;
}
.lf_box{
  width: 500px;
  margin-right: 10px;
}
.title{
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.tile{
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.sam_box{
  margin-bottom: 10px;
}
.userInfo{
  margin-bottom:80px;
}
</style>
<style>
.art_box .el-form-item{
  width: 400px;
}
.art_box .el-select{
  width: 300px;
}
</style>

